import './layout.css'
import { useState } from 'react'
import { useMsal } from "@azure/msal-react";
import MenuTab from './MenuTab'
import { SignInButton } from "./SignInButton";


function Header({ appName, userName, menuItems, userPermissions }) {
    const [selectedTab, setSelectedTab] = useState('');
    const { instance } = useMsal();

    const handleLogout = () => {
        instance.logoutRedirect();
    };

    return (
        <div className='header'>
            <div className='header-top'>
                <p className='header-appname'>{appName}</p>
                {userName ? <p className='header-username'>{userName}</p> : <SignInButton />}
                {userName ? <p className='header-username' style={{ cursor: "pointer" }} onClick={() => handleLogout()}>Logout</p> : <></>}
            </div>
            <div className='header-bottom'>
                <ul className='menu-items'>
                    {menuItems &&
                        menuItems.map((item, index) => {
                            if ((item.title == "Administration" && userPermissions.isAdmin) ||
                                (item.title == "Data" && userPermissions.isSubmitter) ||
                                (item.title == "Reports" && userPermissions.isViewer)) {
                                return (
                                    <li
                                        key={index}
                                        className='menu-item'
                                        onMouseEnter={() => setSelectedTab(item.title)}
                                        onMouseLeave={() => setSelectedTab('')}>
                                        <MenuTab title={item.title} menuItems={item.menuItems} selected={selectedTab === item.title} />
                                    </li>
                                )
                            }
                        })}
                </ul>
            </div>
        </div>
    )
}

export default Header